/**
 * Shared body scroll lock.
 *
 * Three overlays hide page scroll while open: the mobile nav drawer
 * (header.js), the leadership bio drawer (leadership.js) and the photo-gallery
 * lightbox (gallery.js). Each carried its own copy of
 * `document.body.style.overflow = 'hidden' | ''`, which had two faults:
 *
 * 1. The release wrote a hardcoded '' rather than restoring whatever was on
 *    body beforehand, so an overlay silently discarded any inline overflow
 *    another script had set.
 * 2. With no shared state, the second overlay to close unlocked scroll while
 *    the first was still open.
 *
 * The reference build is split on this and neither half is the house rule:
 * Header.jsx:77 and About.jsx:461 reset to '', while Training.jsx:55-59 and
 * Projects.jsx:73-77 save and restore. Save-and-restore is the superset — it
 * behaves identically to a reset whenever the saved value is '', which is the
 * normal case — so all three callers use it here.
 *
 * Ownership is a Set, not a depth counter, because header.js's setDrawer(false)
 * runs on every drawer link click and on the desktop-breakpoint resize whether
 * or not the drawer was open. A counter would go negative and desync; adding
 * and deleting a key is idempotent. Pass the overlay element as the owner so
 * two instances of the same block cannot release each other's lock.
 */

const owners = new Set();
let saved = '';

export function setScrollLock(owner, locked) {
	const wasLocked = owners.size > 0;

	if (locked) {
		owners.add(owner);
	} else {
		owners.delete(owner);
	}

	const isLocked = owners.size > 0;

	if (!wasLocked && isLocked) {
		saved = document.body.style.overflow;
		document.body.style.overflow = 'hidden';
	} else if (wasLocked && !isLocked) {
		document.body.style.overflow = saved;
		saved = '';
	}
}
